var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"append-to-body":true,"title":"提示","visible":_vm.showDialog,"width":"400px","height":"200px","showClose":false,"close-on-click-modal":false,"top":"30vh"},on:{"update:visible":function($event){_vm.showDialog=$event}}},[_c('div',[_vm._v(_vm._s(_vm.dialogMessage)),_c('img',{attrs:{"src":"image/running2.gif"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }